import { z } from "zod";

const AddCitySchema = z.object({
  name: z
    .string()
    .nonempty("City name is required.")
    .trim()
    .min(2, "City name must be at least 2 characters"),
  state: z.string().nonempty("State / Province is required.").trim(),
  country: z.string().nonempty("Country is required.").trim(),
  country_abbr: z
    .string()
    .nonempty("Country abbreviation is required.")
    .trim()
    .min(2, "Country abbreviation is required."),
  is_active: z.boolean(),
});

export default AddCitySchema;
